export default "__VITE_ASSET__C7flOaKK__"